import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { ValidatorsService } from 'src/app/shared/services/validators.service';

export interface INewPasswordForm {
  verificationCode: string;
  password: string;
  confirmPassword: string;
}

@Component({
    selector: 'auth-new-password-form',
    templateUrl: './new-password-form.component.html',
    styleUrls: ['./new-password-form.component.scss'],
    standalone: false
})
export class NewPasswordFormComponent implements OnInit {
  form: FormGroup;
  formErrors: Map<string, string> = new Map<string, string>();

  patternReference: any = {};

  @Output()
  onSubmit: EventEmitter<INewPasswordForm> = new EventEmitter<INewPasswordForm>();

  get verificationCodePlaceHolder(): string {
    return this.translationService.translate('Auth.VerificationCode');
  }

  get passwordPlaceHolder(): string {
    return this.translationService.translate('Auth.Password');
  }

  get confirmPasswordPlaceHolder(): string {
    return this.translationService.translate('Auth.ConfirmPassword');
  }

  constructor(
    private fb: FormBuilder,
    //private translate: TranslateService,
    public validators: ValidatorsService,
    private translationService: TranslationService) { }

  ngOnInit() {
    /*
    this.form = this.fb.group({
      'verificationCode': ['', this.validators.formBuilderValidationInitializer(true, null, null)],
      'password': ['', this.validators.formBuilderValidationInitializer(true, null, null)],
      'confirmPassword': ['', this.validators.formBuilderValidationInitializer(true, null, null)],
    });
    */
    this.form = this.fb.group({
      verificationCode: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null),
        updateOn: 'change'
      }),
      password: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null),
        updateOn: 'change'
      }),
      confirmPassword: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null),
        updateOn: 'change'
      })
    });

    /*
    this.form["patternReference"] = {
      verificationCode: null,
      password: null,
      confirmPassword: null
    };
    */
    this.patternReference = {
      verificationCode: null,
      password: null,
      confirmPassword: null
    };

    //this.validators.trackInputChange(this.form);
    this.validators.trackInputChange(this.form, this.patternReference);
  }

  submit() {

    //sanitizing
    this.form.setValue(this.validators.multiSanitizerInput(this.form.value));

    if (!this.form.valid)
      return;

    this.formErrors.clear();

    this.onSubmit.emit({
      verificationCode: this.form.get("verificationCode").value,
      password: this.form.get("password").value,
      confirmPassword: this.form.get("confirmPassword").value,
    });
  }
}
